module.exports = __webpack_public_path__ + "static/media/1011659.c5496731.png";